import { createNovelRunsApi } from './runs.js'
import { createNovelStudioApi } from './studio.js'

import { createNovelCatalogApi } from './catalog.js'
import { createNovelTtsApi } from './tts.js'
import { createNovelDramaApi } from './drama.js'
import { createStoryFilmApi } from './story-film.js'

/**
 * 互动小说模式的 api-sdk 域聚合入口（聚合入口：各任务只追加自己的子域，改前重读）。
 * @param {{ request: Function, stream: Function }} transport
 */
export function createNovelApi(transport) {
  return {
    runs: createNovelRunsApi(transport),
    studio: createNovelStudioApi(transport),
    catalog: createNovelCatalogApi(transport),
    tts: createNovelTtsApi(transport),
    drama: createNovelDramaApi(transport),
    story_film: createStoryFilmApi(transport),
  }
}
